import React from "react";
import lootie from "../assets/images/login-animate1.json";
import Lottie from "react-lottie";
import { Link } from "react-router-dom";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { Input, Typography, Button } from "@material-tailwind/react";

function ForgetLogin({
  handleLogin,
  Email,
  setEmail,
  Password,
  setPassword,
  loading,
}) {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: lootie,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  return (
    <div className="flex h-screen">
      {/* Left Pane */}
      <div className="hidden lg:flex items-center justify-center flex-1 bg-white text-black">
        <div className="max-w-md text-center">
          <Lottie options={defaultOptions} />
        </div>
      </div>
      {/* Right Pane */}
      <div className="w-full bg-gray-100 lg:w-1/2 flex items-center justify-center">
        <div className="max-w-md w-full p-6">
          <Typography
            variant="h2"
            color="blue-gray"
            className="text-center mb-12"
          >
            Reset Password
          </Typography>
          <Typography
            variant="h6"
            className="text-blue-gray-200 text-sm text-center mb-7"
          >
            Contact your administrator
          </Typography>
          <form className="space-y-4" onSubmit={handleLogin}>
            <div>
              <Typography className="mb-1 " variant="h6">
                Email
              </Typography>
              <Input
                type="email"
                name="email"
                label="Email"
                size="lg"
                autoComplete="off"
                value={Email}
                placeholder="name@example.com"
                onChange={(e) => setEmail(e.target.value)}
                className="focus:!border-2 focus:!border-t-0 focus:!border-black"
              />
            </div>
            <div>
              <Typography className="mb-1 " variant="h6">
                Password
              </Typography>
              <Input
                type="password"
                name="password"
                label="Password"
                size="lg"
                autoComplete="off"
                value={Password}
                placeholder="Password"
                onChange={(e) => setPassword(e.target.value)}
                className="focus:!border-2 focus:!border-t-0 focus:!border-black"
              />
            </div>
            <div className="text-end cursor-pointer">
              <div className="text-black">
                <Link className="no-underline hover:!text-black" to={"/login"}>
                  <KeyboardBackspaceIcon className="mb-1" />
                  <span className="hover:ml-1">Back to Login</span>
                </Link>
              </div>
            </div>
            <div>
              <Button
                type="submit"
                size="lg"
                className={`w-full text-center mt-2 ${
                  loading ? "flex justify-center items-center" : ""
                }`}
                loading={loading}
              >
                Admin Login
              </Button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default ForgetLogin;
